import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import './index.styles.css'
interface RadioBoxProps {
  checked: boolean
  disabled?: boolean
}

const RadioBox = ({ checked, disabled = false }: RadioBoxProps) => {
  return (
    <div
      role="radio"
      aria-checked={checked}
      tabIndex={0}
      className={[
        'SelectListItem_radio',
        checked && 'SelectListItem_radioChecked',
        disabled && 'SelectListItem_radioDisabled',
      ]
        .filter(Boolean)
        .join(' ')}
    />
  )
}

interface Props {
  disabled?: boolean
  radio?: React.ReactNode
  illustration?: (selected: boolean) => React.ReactNode
  label: string
  onClick: () => void
  selected: boolean
  right?: React.ReactNode
}

const SelectListItem = ({
  disabled = false,
  radio,
  illustration,
  label,
  onClick,
  selected,
  right,
}: Props) => {
  const getColor = () => {
    if (disabled) return 'grey400'

    return selected ? 'viridian1000' : 'grey800'
  }

  const color = getColor()

  const click = () => {
    if (disabled) return

    onClick()
  }

  const getRadio = () => {
    if (radio) return radio

    return <RadioBox disabled={disabled} checked={selected} />
  }

  return (
    <Box
      alignItems="center"
      flexDirection="row"
      justifyContent="spaceBetween"
      background={selected ? 'viridian100' : 'grey000White'}
      border={{
        all: {
          width: 's1',
          color: selected ? 'viridian100' : 'grey400',
          style: 'solid',
        },
      }}
      borderRadius={{ all: 'abs008' }}
      cursor={disabled ? 'default' : 'pointer'}
      paddingY="s8"
      paddingX="s16"
      onClick={click}
      style={{ minHeight: '54px' }} // TODO: Review this!
      aria-selected={selected}
    >
      <Box flexDirection="row" alignItems="center">
        <Box alignItems="center" flexDirection="row" gap="s16">
          {!!illustration && illustration(selected)}
          <Text.Normal size="200" ellipsis color={color}>
            {label}
          </Text.Normal>
        </Box>

        {right}
      </Box>
      <Box>{getRadio()}</Box>
    </Box>
  )
}

export default SelectListItem
